import { Button } from 'antd';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconCopy } from '../BasicComponents/Icons';

type Props = {
  eventId: string;
};

export const EventDuplicateButton: FC<Props> = ({ eventId }) => {
  const navigate = useNavigate();

  return (
    <Button
      icon={<IconCopy />}
      onClick={() => navigate(`/admin/events/${eventId}/advanced/duplicate`)}
    >
      Duplicate Tracking Map
    </Button>
  );
};
